import "./textT1.css";
import { useEffect, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";

const TextBoxT1 = ({
  placeholder,
  setText,
  text,
  headerText,
  jsonText,
  clsname = "",
  inputType = "text",
  sla = "",
  toolTip = "",
  disabled,
  validateIsErr,
  errText = "",
  minLength = "",
  maxLength = "",
}) => {
  const [minTime, setMinTime] = useState("");
  const [txtCss, setTxtCss] = useState("txtBox2");

  function handleChange(evt) {
    const { name, value } = evt.target;

    setText((prev) => {
      const updatedText = {
        ...prev,
        [name]: value,
      };

      if (name === "referensnummer") {
        if (prev.kommun && value) {
          updatedText.shortDesc = `${prev.kommun} - ${value}`;
        } else if (prev.kommun) {
          updatedText.shortDesc = `${prev.kommun} - `;
        } else {
          updatedText.shortDesc = value;
        }
      }

      return updatedText;
    });
  }

  useEffect(() => {
    const errorCheck = async () => {
      if (validateIsErr[jsonText] === true) {
        setTxtCss(txtCss + " txtBox2_error");
      } else {
        setTxtCss(txtCss);
      }
    };
    errorCheck();
  }, [validateIsErr]);

  function isError() {
    if (validateIsErr[jsonText] === true) {
      console.log("txtBox2_error");
      return "txtBox2_error";
    } else {
      return "";
    }
  }

  function isDisabled() {
    let ret = false;
    if (
      minTime === "" &&
      (jsonText === "requiredStartDate" || jsonText === "requiredEndDate")
    ) {
      ret = true;
    } else if (disabled) {
      ret = true;
    } else {
    }
    return ret;
  }
  return (
    <>
      <h6 className="txtH6">
        {headerText}{" "}
        <FaInfoCircle
          id={`info-circel-${jsonText}`}
          data-tooltip-content={toolTip}
          display={toolTip.length === 0 ? "none" : ""}
        />
        <Tooltip
          anchorId={`info-circel-${jsonText}`}
          multiline={true}
          data-html={true}
          className="infoCircelTop2"
        />
      </h6>
      <input
        type="text"
        placeholder={placeholder}
        className={
          (validateIsErr[jsonText] === true
            ? "txtBox2 txtBox2_error "
            : "txtBox2 ") + clsname
        }
        value={text[jsonText]}
        onChange={handleChange}
        name={jsonText}
        min={minTime}
        disabled={isDisabled()}
        minLength={minLength}
        maxLength={maxLength}
      />
      <br />
      <small className="errSmall">
        {validateIsErr[jsonText] === true ? errText : ""}
      </small>
    </>
  );
};

export default TextBoxT1;
